import {
  Icon,
  MenuGroup,
  Menu,
  MenuItem,
  MenuList,
  MenuToggle,
} from '@tonic-one/react';
import { MoreIcon } from '@tonic-one/react-icons';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { V1InstanceApi } from '@Apis';
import { isInUIC } from '@Utils/common';
import { ContextMenuActionKey, ContextMenuItem } from '@Types/v1';

type ActionKeys = Partial<{
  [K in ContextMenuActionKey]: ContextMenuItem;
}>;

export default function ContextMenu({
  user,
  responseActionShow = true,
  securityAwarenessShow = true,
}: {
  user: string;
  responseActionShow?: boolean;
  securityAwarenessShow?: boolean;
}) {
  const { t } = useTranslation();
  const [actions, setActions] = useState<ActionKeys>({
    [ContextMenuActionKey.DisableUserAccount]: {} as ContextMenuItem,
    [ContextMenuActionKey.ResetPassword]: {} as ContextMenuItem,
    [ContextMenuActionKey.SignOut]: {} as ContextMenuItem,
  });
  const goTrainingCampaign = useCallback(async () => {
    try {
      const userInfo: any = await V1InstanceApi.getUserInfoFromDL(user);
      if (userInfo.assetID) {
        const campaignPreparationUuid: any =
          await V1InstanceApi.getUserCampaignPreparationUuid(userInfo.assetID);
        if (campaignPreparationUuid) {
          (window as any).top?.APP?.$router.push(
            `/app/saa?p=training/create?cid=${campaignPreparationUuid.campaignPreparationUuid}`
          );
        }
      }
    } catch (error) {
      console.error(error);
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    }
  }, [user, t]);

  useEffect(() => {
    if (responseActionShow && isInUIC() && window.xdrContextMenu) {
      const res: ContextMenuItem[] = window.xdrContextMenu.query(
        'UserAccount',
        [
          { key: 'linked_from', value: 'cas' },
          { key: 'source_name', value: 'cas' },
          { key: 'source_id', value: '' },
          { key: 'full_user', value: `${user}` },
          { key: 'product_code', value: 'sca' },
          { key: 'sc_user_account', value: `${user}` },
          { key: 'account', value: `${user}` },
          { key: 'target_type', value: 'UserAccount' },
        ],
        true,
        false
      );
      const result = res.reduce(
        (acc: { [key: string]: ContextMenuItem }, item: ContextMenuItem) => {
          acc[item.action_key] = item;
          return acc;
        },
        {}
      );
      setActions(result);
    }
  }, [user, responseActionShow]);
  return (
    <Menu>
      <MenuToggle _hover={{ color: '#578aef' }}>
        <Icon as={MoreIcon} />
      </MenuToggle>
      <MenuList
        PopperProps={{
          modifiers: [
            {
              name: 'flip',
            },
          ],
          usePortal: true,
        }}
      >
        {securityAwarenessShow && (
          <MenuGroup title={t('common.ctxMenu.securityAwareness')}>
            <MenuItem pl={24} onClick={goTrainingCampaign}>
              {t('common.ctxMenu.createTrainingCampaign')}
            </MenuItem>
          </MenuGroup>
        )}

        {responseActionShow && (
          <MenuGroup title={t('common.ctxMenu.response')}>
            {actions[ContextMenuActionKey.DisableUserAccount] && (
              <MenuItem
                onClick={() => {
                  window.xdrContextMenu?.takeAction(
                    actions[ContextMenuActionKey.DisableUserAccount]
                  );
                }}
                pl={24}
              >
                {t('common.action.label.disableUserAccount')}
              </MenuItem>
            )}
            {actions[ContextMenuActionKey.SignOut] && (
              <MenuItem
                onClick={() => {
                  window.xdrContextMenu?.takeAction(
                    actions[ContextMenuActionKey.SignOut]
                  );
                }}
                pl={24}
              >
                {t('common.action.label.forceSignOut')}
              </MenuItem>
            )}
            {actions[ContextMenuActionKey.ResetPassword] && (
              <MenuItem
                onClick={() => {
                  window.xdrContextMenu?.takeAction(
                    actions[ContextMenuActionKey.ResetPassword]
                  );
                }}
                pl={24}
              >
                {t('common.action.label.forceResetPassword')}
              </MenuItem>
            )}
          </MenuGroup>
        )}
      </MenuList>
    </Menu>
  );
}
